;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk'

export function initFaro({
  url,
  appName,
  appVersion,
}: {
  url: string
  appName: string
  appVersion: string
}) {
  initializeFaro({
    url,
    app: {
      name: appName,
      version: appVersion,
    },
    instrumentations: getWebInstrumentations(),
  })
}
